import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const IncSizeField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.incSize && touched.incSize}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Increment Size
                </FormLabel>
                <Field
                    name="incSize"
                    render={({ field }) => (
                        <NumberField
                            {...field}
                            min={1}
                            customWidth="100%"
                            placeholder="Enter increment size"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Must divide evenly into minimum channels."
                        ariaLabel="trunk-type-inc-size-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.incSize}</FieldError>
        </FormControl>
    );
};

export default IncSizeField;
